import config from "../../config/config.json";
import { headers } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
  cancelPreviousRequest,
  decryptResponse,
  headersWithoutAuthWithoutBody
} from "../../APIHelpers/Responses";

export const pageServices = {
  addUpdatePage,
  getPageDetails,
  getPageDetailById
};

// Add Update Page
async function addUpdatePage(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addUpdatePage`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Get Page Details
async function getPageDetails() {
  try {
    const signal = cancelPreviousRequest(`getPageDetails`);
    let apiURL = `${config.API_URL_USER_ONBOARDING}getPageDetails`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if(data?.statusCode === 401){
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Page Details By Id
async function getPageDetailById(id) {
  try {
    const signal = cancelPreviousRequest(`getPageDetailById/${id}`);
    let apiURL = `${config.API_URL_USER_ONBOARDING}getPageDetailById/${id}`
    const response = await fetch(apiURL, {
      ...headersWithoutAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if(data?.statusCode === 401){
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}